import React from 'react';
import { AlertTriangleIcon, InfoIcon } from 'lucide-react';
export function RangeAccessNotice() {
  return <div className="w-full pt-12 md:pt-16" style={{
    backgroundColor: '#f8f6f0'
  }} data-id="element-494">
      <div className="max-w-5xl mx-auto px-4 md:px-8" data-id="element-495">
        {/* Range Access Limitations Notice */}
        <div className="flex items-start gap-4 p-5 rounded-xl mb-6" style={{
        backgroundColor: '#fffbeb',
        border: '2px solid #c8a84b'
      }} data-id="element-496">
          <AlertTriangleIcon size={24} className="flex-shrink-0 mt-0.5" style={{
          color: '#c8a84b'
        }} data-id="element-497" />
          <div data-id="element-498">
            <p className="text-base font-bold mb-2" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-499">
              Limitations to indoor/outdoor range access:
            </p>
            <p className="text-sm text-gray-700 mb-2" style={{
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-500">
              Indoor range during hall rentals or showings &amp; New Member
              Orientations. Specific ranges during league events. All ranges
              except Sporting Clays during Police Dept. Training.
            </p>
            <p className="text-sm font-semibold italic" style={{
            color: '#1e3d2f',
            fontFamily: 'Inter, sans-serif'
          }} data-id="element-501">
              Check the calendar for these events. It is a shame to drive all
              the way to the club and not be able to shoot because you failed to
              check the schedule.
            </p>
          </div>
        </div>

        {/* Hint */}
        <div className="flex items-start gap-3 p-4 rounded-xl" style={{
        backgroundColor: '#f0f7f3',
        border: '1px solid #1e3d2f'
      }} data-id="element-502">
          <InfoIcon size={20} className="flex-shrink-0 mt-0.5" style={{
          color: '#1e3d2f'
        }} data-id="element-503" />
          <p className="text-sm font-medium" style={{
          color: '#1e3d2f',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-504">
            <strong data-id="element-505">HINT:</strong> If you choose to view the calendar{' '}
            <u data-id="element-506">Week</u> by <u data-id="element-507">Week</u> you will get a much better picture of
            events taking place.
          </p>
        </div>
      </div>
    </div>;
}